import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TT2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TT2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_759)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#E31D1C"
        />
        <mask
          id="mask0_1813_759"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_759)">
          <path
            d="M22.2884 22.2669L21.7456 22.7108L21.2662 22.199L-1.4919 -2.10004L-2.04022 -2.68549L-1.4193 -3.19329L0.902958 -5.09253L1.4458 -5.53648L1.92517 -5.02465L24.6832 19.2744L25.2316 19.8598L24.6107 20.3676L22.2884 22.2669Z"
            fill="#272727"
            stroke="#F7FCFF"
            strokeWidth="1.5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_759">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TT2418Icon;
